import React, { Component } from 'react';
import {firebaseApp} from '../firebase';

class Admin extends Component {

    state = {
        mediaGeralWanessa: 0,
        mediaGeralMayanna: 0,
        mediaGeralHugo: 0,
        mediaGeralTemistocles: 0,
        mediaGeralRecepcao: 0,
        mediaGeralEquipe: 0,
        mediaGeralEspacoFisico: 0,
        qtdIndicacaoInternet: 0,
        qtdIndicacaoMedico: 0,
        qtdIndicacaoAmigo: 0,
    }
    
    componentWillMount(){
        const database = firebaseApp.database();
        let ref = database.ref();
        ref.on('value', this.gotData, this.ErrData);
    }

    gotData = (data) => {
        var somaNotaWanessa = 0, somaNotaMayanna = 0, somaNotaHugo = 0, somaNotaTemistocles = 0;
        var qtdWanessa = 0, qtdMayanna = 0, qtdHugo = 0, qtdTemistocles = 0;
        var somaNotaEquipe = 0, somaNotaRecepcao = 0, somaNotaEspacoFisico = 0;

        var respostas = data.val();
        var keys = Object.keys(respostas);
        for(var i = 0; i < keys.length; i++ ){
            var k = keys[i];

            // Definir média da nota dos médicos
            var medico = respostas[k].medico;

            if(medico === "Dra. Wanessa"){
                qtdWanessa = qtdWanessa + 1;
                somaNotaWanessa = somaNotaWanessa + respostas[k].avaliacaoMedico;
            }else if(medico === "Dra. Mayanna"){
                qtdMayanna = qtdMayanna + 1;
                somaNotaMayanna = somaNotaMayanna + respostas[k].avaliacaoMedico;
            }else if(medico === "Dr. Hugo"){
                qtdHugo = qtdHugo + 1;
                somaNotaHugo = somaNotaHugo + respostas[k].avaliacaoMedico;
            }else if(medico === "Dr. Temistocles"){
                qtdTemistocles = qtdTemistocles + 1;
                somaNotaTemistocles = somaNotaTemistocles + respostas[k].avaliacaoMedico;
            }

            // Definir média da clínica
            somaNotaEquipe = somaNotaEquipe + respostas[k].avaliacaoEquipe;
            somaNotaRecepcao = somaNotaRecepcao + respostas[k].avaliacaoRecepcao;
            somaNotaEspacoFisico = somaNotaEspacoFisico + respostas[k].avaliacaoEspacoFisico;

            // Retorna o quantidade de indicações
            var comoConheceu = respostas[k].comoConheceu;
            if(comoConheceu === "indicacao-internet"){
                this.setState({qtdIndicacaoInternet: this.state.qtdIndicacaoInternet + 1})
            } else if(comoConheceu === "indicacao-amigo"){
                this.setState({qtdIndicacaoAmigo: this.state.qtdIndicacaoAmigo + 1})
            } else if(comoConheceu === "indicacao-medico"){
                this.setState({qtdIndicacaoMedico: this.state.qtdIndicacaoMedico + 1})
            }

        }

        this.setState({
            mediaGeralWanessa: (somaNotaWanessa / qtdWanessa),
            mediaGeralMayanna: (somaNotaMayanna / qtdMayanna),
            mediaGeralHugo: (somaNotaHugo / qtdHugo),
            mediaGeralTemistocles: (somaNotaTemistocles / qtdTemistocles),
            mediaGeralEquipe: (somaNotaEquipe / keys.length),
            mediaGeralRecepcao: (somaNotaRecepcao / keys.length),
            mediaGeralEspacoFisico: (somaNotaEspacoFisico / keys.length),
        })
    }

    render() {
        return (
            <div className="container" style={{marginTop:"2%"}}>
                {/* Linha para exibição do Resultado */}

                <center>
                    <h2><strong>Avaliação por médico</strong></h2>
                    <br />
                </center>

                <div className="row">
                    <div className="col-md-3" style={{marginBottom:'7%'}}>
                        <center>
                            <h4><strong>Dra. Wanessa</strong></h4>
                            <hr />
                            <h5>{parseFloat(this.state.mediaGeralWanessa).toFixed(2)}/5</h5>
                        </center>
                    </div>

                    <div className="col-md-3" style={{marginBottom:'7%'}}>
                        <center>
                            <h4><strong>Dra. Mayanna</strong></h4>
                            <hr />
                            <h5>{parseFloat(this.state.mediaGeralMayanna).toFixed(2)}/5</h5>
                        </center>
                    </div>

                    <div className="col-md-3" style={{marginBottom:'7%'}}>
                        <center>
                            <h4><strong>Dr. Hugo</strong></h4>
                            <hr />
                            <h5>{parseFloat(this.state.mediaGeralHugo).toFixed(2)}/5</h5>
                        </center>
                    </div>

                    <div className="col-md-3" style={{marginBottom:'7%'}}>
                        <center>
                            <h4><strong>Dr. Temistocles</strong></h4>
                            <hr />
                            <h5>{parseFloat(this.state.mediaGeralTemistocles).toFixed(2)}/5</h5>
                        </center>
                    </div>

                </div>

                    {/*  Linha de relatórios de Avaliação da clínica */}

                
                    <center>
                        <h2><strong>Avaliação da Clínica</strong></h2>
                        <br />
                    </center>

                    <div className="row" >
                    <div className="col-md-4" style={{marginBottom:'7%'}}>
                        <center>
                            <h4><strong>Recepção</strong></h4>
                            <hr />
                            <h5>
                                {parseFloat(this.state.mediaGeralRecepcao).toFixed(2)}/5
                            </h5>
                        </center>
                    </div>

                    <div className="col-md-4" style={{marginBottom:'7%'}}>
                        <center>
                            <h4><strong>Equipe</strong></h4>
                            <hr />
                            <h5>
                            {parseFloat(this.state.mediaGeralEquipe).toFixed(2)}/5</h5>
                        </center>
                    </div>

                    <div className="col-md-4">
                        <center>
                            <h4><strong>Espaço físico</strong></h4>
                            <hr />
                            <h5>
                            {parseFloat(this.state.mediaGeralEspacoFisico).toFixed(2)}/5
                            </h5>
                        </center>
                    </div>
                    
                    </div>
                
                {/* Linha de relatório de Indicações  */}

                <center>
                        <h2><strong>Indicações</strong></h2>
                        <br />
                    </center>

                    <div className="row">
                    <div className="col-md-4" >
                        <center>
                            <h4><strong>Amigos</strong></h4>
                            <hr />
                            <h5>
                                {this.state.qtdIndicacaoAmigo}
                            </h5>
                        </center>
                    </div>

                    <div className="col-md-4" style={{marginBottom:'7%'}}>
                        <center>
                            <h4><strong>Médicos</strong></h4>
                            <hr />
                            <h5>
                                {this.state.qtdIndicacaoMedico}
                            </h5>
                        </center>
                    </div>

                    <div className="col-md-4">
                        <center>
                            <h4><strong>Internet e Redes Sociais</strong></h4>
                            <hr />
                            <h5>
                                {this.state.qtdIndicacaoInternet}
                            </h5>
                        </center>
                    </div>
                    
                    </div>
                

                {/* Linha para retorno a tela de formulário */}
                <div>
                <center>
                    <button type="submit" className="btn btn-block btn-home" style={{marginBottom: '5%'}} onClick={() => {
                            this.props.history.push({pathname:`/`})
                        }}>
                        Tela inicial
                    </button>
                </center>
                </div>
            </div>
        );
    }
}

export default Admin;